import { forwardRef, type Ref, type SVGProps } from "react";

function SvgDollarWithCircle(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
      <circle cx={12} cy={12} r={10.75} stroke="url(#dollar_with_circle_svg)" strokeWidth={2.5} />
      <path
        stroke="#0C1C43"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.5}
        d="M12 7.91V7m0 9.09V17m1.732-7.727c-.345-.544-.992-.91-1.732-.91h-.222c-.982 0-1.778.724-1.778 1.617v.07c0 .638.397 1.221 1.025 1.507l1.95.886c.628.286 1.025.87 1.025 1.508 0 .93-.83 1.685-1.854 1.685H12c-.74 0-1.387-.365-1.732-.909"
      />
      <defs>
        <linearGradient
          id="dollar_with_circle_svg"
          x1={12}
          x2={12}
          y1={0}
          y2={24}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ADF3C7" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgDollarWithCircle);
export default ForwardRef;
